import { Component, OnInit } from '@angular/core';
import { MobileAppWrapper } from '../mobile.app.wrapper.component';
import { JoiApp } from 'globals/store/app.data';
import { getDefaultProgramTabNames } from 'globals/store/share.data';
import { loadProgramTexts } from 'globals/store/programs.data';
import { PerformerGalleryComponent } from 'src/app/modules/performers/performer-gallery.component';
import { mobileAppFeature } from '../mobile-store/mobile.app.era';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'mobile-app-performers',
    template: `
<performer-gallery *ngIf="!!app?.eventData"
  [joiEvent]="app.eventData.eventInfo"
  [timeline]="app.eventData.timeline"
  [programTexts]="programTexts"
  [isPreview]="false"
  [entityName]="tabNames['performersTab']"
  [hidePhotos]="!!app.eventData.excludedFieldIds.includes('performerProfilePhotoUrl')"
  [hideSessions]="!!app.eventData.excludedFieldIds.includes('includePerformerSessions')"
  (scrollUp)="scrollUp()"
></performer-gallery>
<div style="flex:1"></div>
`,
    styleUrls: ['./mobile-entities.scss'],
    standalone: true,
    imports: [PerformerGalleryComponent, CommonModule]
})
export class MobileAppPerformersComponent extends MobileAppWrapper<MobileAppPerformersComponent> {
  app: JoiApp
  programTexts = {}
  tabNames:{ [tId: string]: string } = getDefaultProgramTabNames() 

  constructor() {
    super()
    this.subCallback(this.store.select(mobileAppFeature.selectApp), app => {
      this.app = app
      if (!app) return
      const { tabNames, timeline, excludedFieldIds, eventInfo } = app.eventData
      if (tabNames) this.tabNames = tabNames
      this.programTexts = loadProgramTexts(timeline, excludedFieldIds, eventInfo.venues)
    })
  }

}

